// Container.tsx
import React from "react";

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties; // ✅ style qo‘shildi
}

const Container: React.FC<ContainerProps> = ({ children, className = "", style }) => {
  return (
    <div
      className={`mx-auto w-full max-w-[1440px] px-4 sm:px-6 lg:px-8 ${className}`}
      style={style}
    >
      {children}
    </div>
  );
};

export default Container;
